import React, { useEffect, useState } from 'react'

//Componentes
import FlexContainer from '../../components/common/FlexContainer'
import Information from './components/Information'
import EditProfile from './components/EditProfile'
import Group from './components/Group'

//Services
import PerfilService from '../../services/PerfilService'

export default function Profile() {
    const [user, setUser] = useState([]);

    useEffect(() => {
        refreshProfile();
    }, [])

    function refreshProfile() {
        PerfilService.obtenerPerfil().then((res) => {
            setUser(res[0]);
        });
    }



    return (
        <FlexContainer flexDirection='row' backgroundColor='transparent' padding='64px'>
            <FlexContainer width='40%' flexDirection='column' backgroundColor='transparent' alignItems='center' justifyContent='center' height='100%'>
                <Information user={user}></Information>
                {user.rol != 'docente' &&
                    <Group user={user} setUser={setUser} refreshProfile={refreshProfile}></Group>
                }
            </FlexContainer>
            <EditProfile usuario={user} setUser={setUser} refreshProfile={refreshProfile}></EditProfile>
        </FlexContainer>
    )
}
